var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.83 54H27V30H81.83L101.83 42L81.83 54ZM33 48H80.17L90.17 42L80.17 36H33V48Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54H57V81H63V54Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24H57V30H63V24Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.54 96C25.7925 96 23.6575 95.13 21.695 94.3275C19.6875 93.5075 17.79 92.735 15 92.735V86.735C18.965 86.735 21.735 87.865 23.96 88.7725C26.6475 89.87 28.27 90.53 31.485 89.47C34.06 88.62 34.845 87.0675 36.0375 84.715C37.4175 81.9925 39.1325 78.6025 44.06 76.975C48.9975 75.3425 52.3675 77.0625 55.0775 78.4425C57.395 79.625 58.925 80.405 61.4875 79.5575C64.0625 78.7075 64.8475 77.155 66.04 74.8025C67.42 72.08 69.1375 68.69 74.0625 67.0625C79 65.43 82.3725 67.15 85.08 68.53C87.3975 69.7125 88.9275 70.4925 91.49 69.645C93.6675 68.925 94.495 67.2375 95.6625 64.5425C97.0425 61.36 98.93 57 105.005 57V63C103.065 63 102.548 63.745 101.168 66.9275C99.9225 69.8025 98.215 73.7425 93.3725 75.3425C88.435 76.975 85.0625 75.255 82.355 73.875C80.0375 72.6925 78.505 71.9125 75.945 72.76C73.37 73.61 72.585 75.1625 71.3925 77.515C70.0125 80.2375 68.295 83.6275 63.37 85.255C58.43 86.8875 55.06 85.1675 52.3525 83.7875C50.035 82.6075 48.505 81.825 45.9425 82.6725C43.3675 83.5225 42.5825 85.075 41.39 87.4275C40.01 90.15 38.295 93.54 33.3675 95.1675C31.555 95.7675 29.965 96 28.5425 96H28.54Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/Directions.bd5e0503.svg";
export { ForwardRef as ReactComponent };